import get from 'lodash/get';
import {
    GET_ORDER_DETAIL,
    SET_LOADER,
    GET_ORDER_DETAIL_SUCCESS,
    GET_ORDER_DETAIL_ERROR,
    GET_ORDER_DETAIL_LOADING_STOP,
} from '../actionTypes/OrderDetailsActionTypes';

function OrderDetailsReducer(state = {}, action = {}) {
    switch (action.type) {
        case GET_ORDER_DETAIL:
        case SET_LOADER: {
            return { ...state, isLoading: true };
        }
        case GET_ORDER_DETAIL_SUCCESS: {
            const payload = get(action, 'payload.response.data', {});
            return { ...state, payload, isSuccess: true, isLoading: false };
        }

        case GET_ORDER_DETAIL_ERROR: {
            const error = get(action, 'error', { errorCode: '' });
            return { ...state, error, isLoading: false };
        }

        case GET_ORDER_DETAIL_LOADING_STOP: {
            const { payload } = action;
            return { ...state, payload, isLoading: false };
        }

        default:
            return state;
    }
}

OrderDetailsReducer.reducerName = 'orderDetails';
export default OrderDetailsReducer;
